__turbopack_context__.v({
  "img": "style-module-scss-module__Zeg6Oa__img",
  "item": "style-module-scss-module__Zeg6Oa__item",
  "list": "style-module-scss-module__Zeg6Oa__list",
  "title": "style-module-scss-module__Zeg6Oa__title",
  "wrapper": "style-module-scss-module__Zeg6Oa__wrapper",
});
